import { useState } from 'react';

type ControllableState<T> = T | undefined;

type UseControllableStateReturn<T> = [T, (newValue: T) => void];

export const useControllableState = <T>(
  controlledValue: ControllableState<T>,
  defaultValue: T,
): UseControllableStateReturn<T> => {
  const [value, setValue] = useState<T>(defaultValue);

  const updateValue = (newValue: T) => {
    if (controlledValue === undefined) {
      setValue(newValue);
    }
  };

  return [controlledValue !== undefined ? controlledValue : value, updateValue];
};
